import React, { useState, useRef } from "react";
import {
  Card,
  CardBody,
  Typography,
  IconButton,
} from "@material-tailwind/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export function CreateImageModal({ formData }) {
  const [mediaPreviews, setMediaPreviews] = useState([]);

  const handleUpload = (event) => {
    const files = event.target.files;
    const newPreviews = [];
    for (let i = 0; i < files.length; i++) {
      formData.current.append("media", files[i]);
      newPreviews.push({
        url: URL.createObjectURL(files[i]),
        type: files[i].type.startsWith("image") ? "image" : "video",
        name: files[i].name,
      });
    }
    setMediaPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
  };

  const handleRemove = (name) => {
    setMediaPreviews((prevPreviews) =>
      prevPreviews.filter((media) => media.name !== name)
    );

    const newFormData = new FormData();
    formData.current.forEach((value, key) => {
      if (value.name !== name) {
        newFormData.append(key, value);
      }
    });
    formData.current = newFormData;
  };

  return (
    <Card className="mx-auto w-full">
      <CardBody className="flex flex-col gap-4 !min-h-[500px]">
        <Typography
          variant="h4"
          color="blue-gray"
          className="!text-lg md:!text-2xl"
        >
          อัปโหลดรูปภาพ/วิดีโอ
        </Typography>
        <label
          className={`flex items-center justify-center border border-black rounded-xl py-3 px-6 gap-x-3 cursor-pointer mb-3 ${
            mediaPreviews.length >= 30 ? "bg-gray-300" : "bg-white"
          }`}
        >
          <input
            type="file"
            accept="image/jpeg,image/png,image/gif,video/*"
            multiple
            disabled={mediaPreviews.length >= 30}
            className="hidden"
            onChange={(event) => {
              if (event.target.files.length + mediaPreviews.length > 30) {
                alert("อัปโหลดได้สูงสุด 30 ไฟล์");
                return;
              }
              handleUpload(event);
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
          </svg>
          คลิกเพื่ออัปโหลด{" "}
          <span className="text-red-500"> *สูงสุด 30 ไฟล์</span>
        </label>
        <Typography
          variant="h6"
          color="blue-gray"
          className="!text-sm md:!text-base"
        >
          จำนวนทั้งหมด {mediaPreviews.length} ไฟล์
        </Typography>
        <div className="grid grid-cols-3 mg:grid-cols-4 gap-2">
          {mediaPreviews.map((media, index) => (
            <div key={index} className="relative col-span-1">
              {media.type === "image" ? (
                <img
                  src={media.url}
                  alt={`Preview ${index}`}
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
              ) : (
                <video
                  src={media.url}
                  controls
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
              )}
              <IconButton
                size="sm"
                variant="filled"
                className="!absolute right-1 top-1 !size-5 rounded-full bg-primaryDark"
                onClick={() => handleRemove(media.name)}
              >
                <XMarkIcon className="h-4 w-4 stroke-2" />
              </IconButton>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}

export default CreateImageModal;
